import React from 'react';
import {
  FormControlLabel,
  Switch,
  FormHelperText,
  Box,
} from '@material-ui/core';
import { VariableEditorProps } from '../types';

export const BoolEditor: React.FC<VariableEditorProps> = ({
  variable,
  value,
  onChange,
  error,
  disabled,
}) => {
  const boolValue = value === true || value === 'true';

  return (
    <Box>
      <FormControlLabel
        control={
          <Switch
            checked={boolValue}
            onChange={e => onChange(e.target.checked)}
            disabled={disabled}
            color="primary"
          />
        }
        label={variable.name}
      />
      {(error || variable.description) && (
        <FormHelperText error={!!error}>
          {error || variable.description}
        </FormHelperText>
      )}
    </Box>
  );
};
